import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { useSelector } from 'react-redux';

import { Button, Col, Row } from 'antd';
import { textSort } from '../../helpers/textSort';
import CustomInputNumber from '../../components/CustomInputNumber/CustomInputNumber';

const MeanLinearReturn = ({t, storedPrimitives, setStoredPrimitives, hendleChangeValue, validate}) => {

  const assets = useSelector((state) => state.instrumentsReducer.assets);

  const [primitivesSet, setPrimitivesSet] = useState(null);

  useEffect(() => {
    if(primitivesSet?.length) {
      validate(primitivesSet.every(i => i.value || i.value === 0), 'meanLinearReturn');
    } else {
      validate(false, 'meanLinearReturn');
    }
  }, [primitivesSet]);
  
  const getAssetById = (id) => {
    const asset = assets.find(asset => asset.ID === id);
    return {name: asset?.name ?? '', category: asset?.financialAssetCategory.name ?? ''};
  };
          
  useEffect(() => {
    if(storedPrimitives) {
      const data = storedPrimitives?.filter( i=> i.entity === 1);
      if(!data?.length) {
        const data = assets?.filter(i=> !i?.is_virtual)?.map(i => ({
          entity: 1,
          value: null,
          p1: null,
          p2: null,
          asset_class_1_id: i.ID,
        }));
        const newPrimitives = [...storedPrimitives, ...data];
        setStoredPrimitives(newPrimitives);
        return;
      }
      setPrimitivesSet(data?.sort((a, b) => textSort(getAssetById(a.asset_class_1_id)?.name, getAssetById(b.asset_class_1_id)?.name)));
    }
  }, [storedPrimitives]);

  const handleClearAll = () => {
    const clonData = cloneDeep(storedPrimitives);
      const newData = clonData.map(i => {
        if(i.entity === 1) {
          const el = {...i, value: null, p1: null, p2: null};
            return el;
        } else {
            return i;
        }
      });
      setStoredPrimitives(newData);
  };

  return (
    <>
      <Row wrap={false} className="primitives-header">
        <Col
          span={8}
          className="primitives-title-class contrast">
          {t('ASSET_CLASS')}
        </Col>
        <Col span={12} className="primitives-title-value">
          {t('VALUE')}
        </Col>
        <Col
          span={4}
          className="asset-class-title-allocation"
        >
          <Button
            className="portfolio-details-btn primitives-clear-btn"
            onClick={handleClearAll}
          >
            {t('CLEAR_ALL')}
          </Button>
        </Col>
      </Row>
      {primitivesSet &&
        primitivesSet?.map((el) => {
          return (
            <Row key={el.asset_class_1_id} wrap={false} className={'primitives-row'}>
              <Col span={8} className="primitives-title-class">
                <div className=''>
                  <p className='primitives-cell-name'>{getAssetById(el.asset_class_1_id)?.name}</p>
                  <p className='primitives-cell-category'>{getAssetById(el.asset_class_1_id)?.category}</p>
                </div>
              </Col>
              <Col span={12} className="primitives-title-value cell">
                <div className=''>
                  <CustomInputNumber
                    width={'132px'}
                    percent
                    precision={2}
                    min={0}
                    value={el?.value || el?.value === 0  ? (el?.value * 100).toFixed(2) : ''}
                    onBlur={(e) =>
                      hendleChangeValue(null, e.target.value, el?.asset_class_1_id, 'value')
                    }
                    className="custom-inputnumber model-series"
                    controls={false}
                  />
                </div>
              </Col>

            </Row>
          );
        }
      )
      }
    </>
  );
};

export default MeanLinearReturn;

MeanLinearReturn.propTypes = {
  t: PropTypes.func.isRequired,
  storedPrimitives: PropTypes.array,
  setStoredPrimitives: PropTypes.func.isRequired,
  hendleChangeValue: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
};
